import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqTooltipComponent } from './components/datiq-tooltip/datiq-tooltip.component';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';

@NgModule({
    imports: [
        CommonModule,
        DatiqIconsModule,
        MatIconModule,
        OverlayModule,
        DatiqTemplateModule,
    ],
    declarations: [DatiqTooltipComponent],
    exports: [DatiqTooltipComponent],
})
export class DatiqTooltipModule {}
